import * as React from 'react';

export function subscribeToRouteChange(Component: any) {

    interface IProps extends IBaseSceneProps {
        routeChange: any;
    }

    class CompletedComponent extends React.Component<IProps> {

        private routeChangeHandler : any;

        public componentWillUnmount() {
            if(this.routeChangeHandler) {
                this.routeChangeHandler(document.location);
            }

        }
        
        public getReference = (ref:any) => {
            if(ref && ref.onRouteChange) {                
                this.routeChangeHandler = ref.onRouteChange;
            }
        }

        public render() {
            return <Component {...this.props} ref={this.getReference} />
        }

    }
    
    return CompletedComponent;
}